import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { ArrowLeft } from 'react-feather';
import { Card, Icon } from 'ui';
import Text, { TEXT_VARIANTS } from 'components/ui/Typography/Text';
import ZoomContext from 'components/InPersonTraining/shared/ZoomContext';
import LinkButton from 'components/shared/LinkButton';
import Tooltip from 'components/shared/Tooltip';
import SessionDetails from 'components/InPersonTraining/shared/SessionDetails';
import EditForm from '../../Session/EditForm';

const SessionOverview = ({
  meta,
  eventId,
  isArchived,
  session,
  sessionCount,
}) => {
  const { currentCompany, currentUser, zoomClientId } = meta;
  const [isEditing, setIsEditing] = useState(false);

  return (
    <ZoomContext.Provider value={{ zoomClientId }}>
      <Link to={`/in_person_training/events/${eventId}`}>
        <button type="button" className="u-linkBtn">
          <div className="d-f ai-c mb-20">
            <ArrowLeft className="mr-10 c-link" size={16} />
            <span className="fz-16 u-linkBtn">
              {t('in_person_training.session.all_sessions')}
            </span>
          </div>
        </button>
      </Link>
      <div className="mb-20">
        <Text variant={TEXT_VARIANTS.SUBHEADER}>{session.name}</Text>
      </div>
      <Card className="EventSession">
        {isEditing && (
          <EditForm
            currentCompany={currentCompany}
            currentUser={currentUser}
            isMultiSession
            onDismiss={() => {
              setIsEditing(false);
            }}
            session={session}
          />
        )}
        {!isEditing && (
          <>
            <Card.Content className="fz-base" padding="medium">
              <div className="d-f jc-sb ai-fs">
                <div className="d-f fd-c">
                  <Text variant={TEXT_VARIANTS.SUBHEADER_BOLD}>
                    {t(
                      'in_person_training.event_overview.session.session_details',
                    )}
                  </Text>
                </div>
                <div>
                  <Tooltip
                    text={
                      isArchived &&
                      t(
                        'in_person_training.event_overview.archived_cannot_be_edited',
                      )
                    }
                  >
                    <LinkButton
                      disabled={isArchived}
                      type="primary"
                      onClick={() => {
                        setIsEditing(true);
                      }}
                    >
                      <Icon name="edit" className="mr-4" />
                      {t('common.edit')}
                    </LinkButton>
                  </Tooltip>
                </div>
              </div>
              <SessionDetails
                className="mt-20"
                session={session}
                eventId={eventId}
                adminView
                hasMultipleSessions={sessionCount > 1}
              />
            </Card.Content>
          </>
        )}
      </Card>
    </ZoomContext.Provider>
  );
};

export default withRouter(SessionOverview);
